import { CustomImg } from './style'

interface BankImageProps {
  uri?: string
  className?: string
  style?: any
}
const BankImage = ({
  uri = 'https://res.cloudinary.com/fandksavings/image/upload/v1618209342/banking-logos/visa_PNG36_qlh3pf.png',
  className,
  style,
}: BankImageProps) => {
  return <CustomImg src={uri} className={className} style={style} />
}

export default BankImage

export const CardImage = ({
  uri = 'https://res.cloudinary.com/dev-ninja/image/upload/v1626654700/credit-card_1_bd5tqj.png',
  className,
  style,
}: BankImageProps) => {
  return <CustomImg src={uri} className={className} style={style} />
}
